import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize } from "react-localize-redux";


import {  removeFieldProgram } from '../../actions/program';

class ProjectItem extends React.Component {

  handleDelete(elm) {
    var result = window.confirm("Voulez vous vraiment enlever ce projet du programme?");
    if (result) {
      this.props.removeFieldProgram(this.props.index,"projects",this.props.docId)
    }
  }

    render() {

        if (this.props.permission.validate) {
            return (
                <li className="line">
                    <div onClick={this.handleDelete.bind(this)} style={{ display: "inline-block", float: "right" }} ><i className="fas fa-trash"></i></div>
                    <Link style={{ height: "30px", lineHeight: "30px", display: "inline-block" }} to={"/project/" + this.props.id}>
                        <div style={{ display: "inline-block", width: "auto", lineHeight: "30px" }}><p>{this.props.value}</p></div>
                    </Link>
                </li>
            );
        } else if (this.props.permission.write) {
            return (
                <li className="line">
                    <Link style={{ height: "30px", lineHeight: "30px", display: "inline-block" }} to={"/project/" + this.props.id}>
                        <div style={{ display: "inline-block", width: "auto", lineHeight: "30px" }}><p>{this.props.value}</p></div>
                    </Link>
                </li>
            );
        } else {
            return (
                <li className="line">
                    <div style={{ display: "inline-block", width: "auto", lineHeight: "30px" }}><p>{this.props.value}</p></div>
                </li>
            );
        }
  }
}

const mapStateToProps = state => ({
  program: state.program.program,
  message: state.program.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
  removeFieldProgram
}, dispatch); 

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(ProjectItem)));